// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vendorsListPage_pageWrap__nMvHG .vendorsListPage_pageHeader__xVB6O {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
}
.vendorsListPage_pageWrap__nMvHG .vendorsListPage_pageHeader__xVB6O h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.vendorsListPage_pageWrap__nMvHG .vendorsListPage_pageHeader__xVB6O .vendorsListPage_right__Op3Dm {
  display: flex;
  align-items: center;
  gap: 20px;
}
.vendorsListPage_pageWrap__nMvHG .vendorsListPage_pageHeader__xVB6O .vendorsListPage_right__Op3Dm .vendorsListPage_date__nc1u8 {
  display: flex;
  align-items: center;
  gap: 4px;
}
.vendorsListPage_pageWrap__nMvHG .vendorsListPage_pageHeader__xVB6O .vendorsListPage_right__Op3Dm .vendorsListPage_date__nc1u8 img,
.vendorsListPage_pageWrap__nMvHG .vendorsListPage_pageHeader__xVB6O .vendorsListPage_right__Op3Dm .vendorsListPage_date__nc1u8 svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.vendorsListPage_pageWrap__nMvHG .vendorsListPage_pageHeader__xVB6O .vendorsListPage_right__Op3Dm .vendorsListPage_date__nc1u8 span {
  font: var(--body-font-four);
  color: var(--primary-Text);
  display: block;
}

.vendorsListPage_warningTextContainer__Ha6Wg {
  display: flex;
  align-items: center;
  gap: 4px;
  font: var(--body-font-four);
  color: var(--primary-Text);
}
.vendorsListPage_warningTextContainer__Ha6Wg span {
  display: block;
}
.vendorsListPage_warningTextContainer__Ha6Wg img {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}

@media (max-width: 767px) {
  .vendorsListPage_pageWrap__nMvHG .vendorsListPage_pageHeader__xVB6O {
    padding: 16px;
  }
  .vendorsListPage_pageWrap__nMvHG .vendorsListPage_pageHeader__xVB6O .vendorsListPage_right__Op3Dm {
    gap: 12px;
  }
  .vendorsListPage_pageWrap__nMvHG .vendorsListPage_pageHeader__xVB6O .vendorsListPage_right__Op3Dm button {
    min-height: 35px;
    padding: 7px 10px;
    font-size: 12px;
    text-align: center;
  }
}
@media (max-width: 425px) {
  .vendorsListPage_pageWrap__nMvHG .vendorsListPage_pageHeader__xVB6O .vendorsListPage_right__Op3Dm .vendorsListPage_date__nc1u8 span {
    display: none;
  }
}
.vendorsListPage_VendorsListModalBody__V1omw {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.vendorsListPage_VendorsListModalBody__V1omw .vendorsListPage_label__q1QzL {
  font: var(--body-font-three);
  color: var(--secondary-Text);
  display: block;
  margin-bottom: 4px;
}
.vendorsListPage_VendorsListModalBody__V1omw .vendorsListPage_summary__e7iLX {
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background-color: var(--white);
  margin-bottom: 16px;
}
.vendorsListPage_VendorsListModalBody__V1omw .vendorsListPage_summary__e7iLX h4 {
  font: var(--body-font-two);
  font-weight: 600;
  margin-bottom: 16px;
}
.vendorsListPage_VendorsListModalBody__V1omw .vendorsListPage_summary__e7iLX ul {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 16px;
}
.vendorsListPage_VendorsListModalBody__V1omw .vendorsListPage_summary__e7iLX ul li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}
.vendorsListPage_VendorsListModalBody__V1omw .vendorsListPage_summary__e7iLX ul li .vendorsListPage_heading__bIdkq {
  font: var(--body-font-three);
  color: var(--primary-Text);
}
.vendorsListPage_VendorsListModalBody__V1omw .vendorsListPage_summary__e7iLX ul li .vendorsListPage_value__Q-WT9 {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--primary-Text);
}
.vendorsListPage_VendorsListModalBody__V1omw .vendorsListPage_summary__e7iLX .vendorsListPage_requirements__uZoSb {
  padding-top: 16px;
}
.vendorsListPage_VendorsListModalBody__V1omw .vendorsListPage_summary__e7iLX .vendorsListPage_requirements__uZoSb .vendorsListPage_heading__bIdkq {
  font: var(--body-font-three);
  color: var(--primary-Text);
  margin-bottom: 8px;
}
.vendorsListPage_VendorsListModalBody__V1omw .vendorsListPage_summary__e7iLX .vendorsListPage_requirements__uZoSb .vendorsListPage_value__Q-WT9 {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--primary-Text);
}`, "",{"version":3,"sources":["webpack://./src/pages/vendors-list/vendorsListPage.module.scss"],"names":[],"mappings":"AACC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;AAAF;AAEE;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AAAH;AAGE;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AADH;AAGG;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AADJ;AAGI;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AADL;AAII;EACC,2BAAA;EACA,0BAAA;EACA,cAAA;AAFL;;AASA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,2BAAA;EACA,0BAAA;AAND;AAOC;EACC,cAAA;AALF;AAOC;EACC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AALF;;AASA;EAEE;IACC,aAAA;EAPD;EASC;IACC,SAAA;EAPF;EASE;IACC,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,kBAAA;EAPH;AACF;AAaA;EAKK;IACC,aAAA;EAfJ;AACF;AAuBA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AArBD;AAuBC;EACC,4BAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;AArBF;AAwBC;EACC,aAAA;EACA,+BAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;AAtBF;AAwBE;EACC,0BAAA;EACA,gBAAA;EACA,mBAAA;AAtBH;AAyBE;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;AAvBH;AAyBG;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAvBJ;AAyBI;EACC,4BAAA;EACA,0BAAA;AAvBL;AA0BI;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;AAxBL;AA6BE;EACC,iBAAA;AA3BH;AA6BG;EACC,4BAAA;EACA,0BAAA;EACA,kBAAA;AA3BJ;AA8BG;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;AA5BJ","sourcesContent":[".pageWrap {\r\n\t.pageHeader {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\t\tpadding: 16px 24px;\r\n\t\tborder-bottom: 1px solid var(--border);\r\n\r\n\t\th1 {\r\n\t\t\tfont: var(--h3);\r\n\t\t\tfont-weight: 700;\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tfont-family: var(--font-bodoni-72);\r\n\t\t}\r\n\r\n\t\t.right {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 20px;\r\n\r\n\t\t\t.date {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 4px;\r\n\r\n\t\t\t\timg,\r\n\t\t\t\tsvg {\r\n\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\theight: 16px;\r\n\t\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\r\n\t\t\t\tspan {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t\tdisplay: block;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.warningTextContainer {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 4px;\r\n\tfont: var(--body-font-four);\r\n\tcolor: var(--primary-Text);\r\n\tspan {\r\n\t\tdisplay: block;\r\n\t}\r\n\timg {\r\n\t\twidth: 16px;\r\n\t\theight: 16px;\r\n\t\tobject-fit: scale-down;\r\n\t\tdisplay: block;\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.pageWrap {\r\n\t\t.pageHeader {\r\n\t\t\tpadding: 16px;\r\n\r\n\t\t\t.right {\r\n\t\t\t\tgap: 12px;\r\n\r\n\t\t\t\tbutton {\r\n\t\t\t\t\tmin-height: 35px;\r\n\t\t\t\t\tpadding: 7px 10px;\r\n\t\t\t\t\tfont-size: 12px;\r\n\t\t\t\t\ttext-align: center;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 425px) {\r\n\t.pageWrap {\r\n\t\t.pageHeader {\r\n\t\t\t.right {\r\n\t\t\t\t.date {\r\n\t\t\t\t\tspan {\r\n\t\t\t\t\t\tdisplay: none;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n\r\n.VendorsListModalBody {\r\n\twidth: 100%;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 16px;\r\n\r\n\t.label {\r\n\t\tfont: var(--body-font-three);\r\n\t\tcolor: var(--secondary-Text);\r\n\t\tdisplay: block;\r\n\t\tmargin-bottom: 4px;\r\n\t}\r\n\r\n\t.summary {\r\n\t\tpadding: 16px;\r\n\t\tborder: 1px solid var(--border);\r\n\t\tborder-radius: 8px;\r\n\t\tbackground-color: var(--white);\r\n\t\tmargin-bottom: 16px;\r\n\r\n\t\th4 {\r\n\t\t\tfont: var(--body-font-two);\r\n\t\t\tfont-weight: 600;\r\n\t\t\tmargin-bottom: 16px;\r\n\t\t}\r\n\r\n\t\tul {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 16px;\r\n\t\t\tpadding-bottom: 16px;\r\n\r\n\t\t\tli {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tjustify-content: space-between;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 16px;\r\n\r\n\t\t\t\t.heading {\r\n\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.value {\r\n\t\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\t\tfont-weight: 500;\r\n\t\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.requirements {\r\n\t\t\tpadding-top: 16px;\r\n\r\n\t\t\t.heading {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tmargin-bottom: 8px;\r\n\t\t\t}\r\n\r\n\t\t\t.value {\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 500;\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `vendorsListPage_pageWrap__nMvHG`,
	"pageHeader": `vendorsListPage_pageHeader__xVB6O`,
	"right": `vendorsListPage_right__Op3Dm`,
	"date": `vendorsListPage_date__nc1u8`,
	"warningTextContainer": `vendorsListPage_warningTextContainer__Ha6Wg`,
	"VendorsListModalBody": `vendorsListPage_VendorsListModalBody__V1omw`,
	"label": `vendorsListPage_label__q1QzL`,
	"summary": `vendorsListPage_summary__e7iLX`,
	"heading": `vendorsListPage_heading__bIdkq`,
	"value": `vendorsListPage_value__Q-WT9`,
	"requirements": `vendorsListPage_requirements__uZoSb`
};
export default ___CSS_LOADER_EXPORT___;
